/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Discovery_BannerInputs */



/**
* | output |
* | --- |
* | "Find your local VTES community and connect with coordinators." |
*
* @param {Tournaments_Discovery_BannerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_discovery_banner = /** @type {((inputs?: Tournaments_Discovery_BannerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Discovery_BannerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trouvez votre communauté VTES locale et connectez-vous avec les coordinateurs.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Encuentra tu comunidad VTES local y conecta con los coordinadores.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encontre sua comunidade VTES local e conecte-se com os coordenadores.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trova la tua comunità VTES locale e connettiti con i coordinatori.")
	return /** @type {LocalizedString} */ ("Find your local VTES community and connect with coordinators.")
});